<div class="min-h-screen p-6">

  <!-- HEADER -->
  <div class="flex justify-between items-center mb-6 flex-wrap gap-3">
    <h1 class="text-2xl font-bold text-gray-800 dark:text-white/90">Calendario</h1>

    <!-- INC 74: alcance Mis reuniones / Todas -->
    <div class="inline-flex rounded-lg border border-gray-300 dark:border-gray-600 p-0.5 bg-gray-50 dark:bg-gray-800">
      <button type="button" (click)="setScope('ALL')"
        class="px-3 py-1.5 text-sm font-medium rounded-md transition-colors"
        [class.bg-brand-500]="scope === 'ALL'"
        [class.text-white]="scope === 'ALL'"
        [class.text-gray-600]="scope !== 'ALL'"
        [class.dark:text-gray-300]="scope !== 'ALL'"
        [class.hover:text-gray-800]="scope !== 'ALL'">
        Todas
      </button>
      <button type="button" (click)="setScope('MINE')"
        class="px-3 py-1.5 text-sm font-medium rounded-md transition-colors"
        [class.bg-brand-500]="scope === 'MINE'"
        [class.text-white]="scope === 'MINE'"
        [class.text-gray-600]="scope !== 'MINE'"
        [class.dark:text-gray-300]="scope !== 'MINE'"
        [class.hover:text-gray-800]="scope !== 'MINE'">
        Mis reuniones
      </button>
    </div>

    <!-- Filtros -->
    <div class="flex gap-2 items-center flex-wrap">
      <select [(ngModel)]="currentMonth" (change)="onMonthChange()"
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90 focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option *ngFor="let m of months; let i = index" [ngValue]="i">{{ m }}</option>
      </select>
      <select [(ngModel)]="currentYear" (change)="onMonthChange()"
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90 focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option *ngFor="let y of years" [value]="y">{{ y }}</option>
      </select>
    </div>

    <!-- Filtro por rango de fechas -->
    <div class="flex gap-2 items-center flex-wrap">
      <input type="date" [(ngModel)]="startFilterDate" (change)="onFilterChange()"
        (click)="$any($event.target).showPicker?.()"
        (focus)="$any($event.target).showPicker?.()"
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90 dark:[color-scheme:dark] cursor-pointer" />
      <input type="date" [(ngModel)]="endFilterDate" (change)="onFilterChange()"
        (click)="$any($event.target).showPicker?.()"
        (focus)="$any($event.target).showPicker?.()"
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90 dark:[color-scheme:dark] cursor-pointer" />
      <button (click)="clearFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        Limpiar
      </button>
    </div>

    <!-- Nueva Reunion -->
    <button routerLink="/meeting/crear"
      class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5 transition-colors">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Nueva Reunión
    </button>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">

    <!-- CALENDARIO -->
    <div class="lg:col-span-8 overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] p-4">

      <!-- NAV -->
      <div class="flex justify-between items-center mb-4">
        <button (click)="prevMonth()"
          class="w-8 h-8 rounded-full flex items-center justify-center text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2 class="font-bold capitalize text-gray-800 dark:text-white/90">{{ getMonthName() }}</h2>
        <button (click)="nextMonth()"
          class="w-8 h-8 rounded-full flex items-center justify-center text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      </div>

      <!-- DÍAS -->
      <div class="grid grid-cols-7 text-center text-xs font-medium mb-2 text-gray-500 dark:text-gray-400">
        <div *ngFor="let d of ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb']" class="py-2">{{ d }}</div>
      </div>

      <!-- GRID -->
      <div class="grid grid-cols-7 gap-1">
        <div *ngFor="let day of days"
          (click)="!day.blocked && selectDate(day.date)"
          class="h-24 p-2 border rounded-lg transition-colors"
          [ngClass]="day.blocked
            ? 'border-gray-300 dark:border-white/[0.08] bg-gray-100 dark:bg-white/[0.04] cursor-not-allowed'
            : 'cursor-pointer ' + (day.isToday
              ? 'border-brand-500 bg-brand-50 dark:bg-brand-500/10'
              : 'border-gray-200 dark:border-white/[0.05] hover:bg-gray-50 dark:hover:bg-white/[0.02]')"
          [class.opacity-40]="!day.isCurrentMonth"
          [title]="day.blocked?.label || ''">

          <div class="relative text-sm font-semibold"
            [ngClass]="day.blocked
              ? 'text-gray-400 dark:text-gray-500 line-through'
              : (day.isToday ? 'text-brand-600 dark:text-brand-400' : 'text-gray-800 dark:text-white/90')">
            {{ day.number }}

            <span *ngIf="day.meetings.length > 0"
              class="absolute -top-2 -right-2 bg-error-500 text-white text-[10px]
                     rounded-full w-5 h-5 flex items-center justify-center font-bold">
              {{ day.meetings.length > 9 ? '9+' : day.meetings.length }}
            </span>
          </div>

          <!-- INC 7: fecha bloqueada por feriado o excepción de disponibilidad -->
          <div *ngIf="day.blocked"
            class="mt-1 inline-flex max-w-full items-center gap-0.5 truncate rounded bg-gray-200 px-1 py-0.5 text-[9px] font-medium text-gray-600 dark:bg-gray-700 dark:text-gray-300">
            🚫 {{ day.blocked.kind === 'holiday' ? 'Feriado' : 'No disponible' }}
          </div>

          <div class="text-[10px] mt-1 space-y-1">
            <div *ngFor="let m of day.meetings.slice(0,2)"
              (click)="openMeetingDetail(m); $event.stopPropagation()"
              class="px-1.5 py-0.5 rounded text-[10px] truncate cursor-pointer hover:opacity-80"
              [ngClass]="getMeetingColor(m.idMeetingType)">
              {{ m.title }}
            </div>
            <div *ngIf="day.meetings.length > 2"
              class="text-[10px] text-gray-500 dark:text-gray-400">
              +{{ day.meetings.length - 2 }} más
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DETALLE -->
    <div class="lg:col-span-4 overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] p-4">
      <h3 class="font-semibold mb-3 text-gray-800 dark:text-white/90">
        {{ selectedDate | date:'fullDate' }}
      </h3>

      <div *ngFor="let m of selectedMeetings"
        class="p-2.5 border border-gray-200 dark:border-white/[0.05] rounded-lg mb-2 hover:bg-gray-50 dark:hover:bg-white/[0.02] transition-colors">

        <div class="font-medium text-sm text-gray-800 dark:text-white/90">{{ m.title }}</div>
        <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ formatHour(m.datetimeStart) }}</div>

        <!-- INC 49: acciones Ver / Editar / Reprogramar / Cancelar -->
        <div class="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1">
          <button (click)="openMeetingDetail(m)"
            class="text-brand-500 hover:text-brand-600 dark:text-brand-400 dark:hover:text-brand-300 text-xs font-medium">
            Ver
          </button>
          <button (click)="viewMeeting(m)"
            class="text-gray-600 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white text-xs font-medium">
            Editar
          </button>
          <button (click)="reprogramarReunion(m)"
            class="text-warning-600 hover:text-warning-700 dark:text-warning-400 dark:hover:text-warning-300 text-xs font-medium">
            Reprogramar
          </button>
          <button (click)="cancelarReunion(m)"
            class="text-error-500 hover:text-error-600 dark:text-error-400 dark:hover:text-error-300 text-xs font-medium">
            Cancelar
          </button>
        </div>
      </div>

      <div *ngIf="selectedMeetings.length === 0"
        class="text-gray-400 dark:text-gray-500 text-sm text-center py-6">
        No hay reuniones
      </div>
    </div>
  </div>
</div>

<app-meeting-detail-modal
  [isOpen]="isModalOpen"
  [meeting]="selectedMeeting"
  (close)="closeModal()">
</app-meeting-detail-modal>

<!-- Modal Cancelar reunión (INC 49) -->
<app-meeting-cancel-dialog
  [isOpen]="showCancelDialog"
  [meeting]="accionMeeting"
  (cancelled)="cerrarCancelDialog()"
  (confirmed)="onAccionConfirmada()">
</app-meeting-cancel-dialog>

<!-- Modal Reprogramar reunión (INC 49) -->
<app-meeting-reschedule-dialog
  [isOpen]="showRescheduleDialog"
  [meeting]="accionMeeting"
  (cancelled)="cerrarRescheduleDialog()"
  (confirmed)="onAccionConfirmada()">
</app-meeting-reschedule-dialog>
